{
  "_comment": [
    "THE single source of truth for every locale on this site.",
    "",
    "It is JSON and not TypeScript because both halves of the stack must read it: src/lib/locale.ts",
    "imports it for the Astro templates and the browser bundle, and the .mjs scripts under scripts/",
    "read it directly. Anything that lived only in locale.ts would have to be duplicated in the",
    "generator and the QA gate, which is the exact duplication this whole architecture exists to avoid.",
    "",
    "ADDING A LOCALE is: a block here, a collection in src/content/config.ts, a route file under",
    "src/pages/<code>/blog/[slug].astro, and a hub page. Never a copy of TranslatedBlogPost.astro, the",
    "generator, or the QA gate.",
    "",
    "`en` is present so the label set has one home, but it is the odd one out: its pages are byte-locked",
    "to 229 captured Webflow pages, so its strings are production's exact strings — trailing space in",
    "writtenBy included — and must not be 'tidied'. scripts/parity-blog.mjs compares them against live.",
    "",
    "`heroReviewedBy` vs `medicallyReviewedBy`: English has two labels because production does, and",
    "parity freezes both. Every translated locale uses the MEDICAL form in both slots — the German tree",
    "flattened to a bare 'Überprüft von' and lost the E-E-A-T signal on all ten pages.",
    "",
    "`chrome` names the src/chrome/ partial for each block, PER LOCALE. It exists because the shared",
    "template briefly hardcoded the .es variants: correct while Spanish was the only translated locale,",
    "and the moment /pt shipped it rendered SPANISH controls on Portuguese pages — 'PRUEBA GRATIS' and",
    "'Preferencias de cookies' on all four. That is the drift seam the docs warn about, realised. A locale",
    "with no partial of its own names the English one explicitly; there is no implicit fallback, because",
    "Chrome.astro throws on a missing variant and a silent fallback is how the wrong language ships.",
    "",
    "`humanSignoff` is PER LOCALE and null means not signed off. The QA gate prints these, and it used to",
    "print Spanish's sign-off during a Portuguese run — presenting an es approval as pt approval on YMYL",
    "medical content. null is the honest default for every new locale.",
    "",
    "`slugs`, when present, is the set that was actually reviewed. A locale-level date without a slug",
    "list used to stamp DONE on every later post in that language — Phase 2 printed as reviewed on",
    "2026-08-08, before those overlays existed. Omit `slugs` only when the whole live set was reviewed."
  ],
  "en": {
    "lang": "en",
    "inLanguage": "en-US",
    "hreflang": "en",
    "base": "/blog",
    "hub": "/blog",
    "collection": "blog",
    "overlayDir": null,
    "dateMonths": null,
    "dateTemplate": null,
    "labels": {
      "published": "Published",
      "updated": "Updated",
      "writtenBy": "Written by ",
      "heroReviewedBy": "Reviewed by",
      "medicallyReviewedBy": "Medically Reviewed by",
      "editorialReviewedBy": "Editorially Reviewed by",
      "editorialTeam": "About Our Editorial Team",
      "references": "References",
      "showAll": "Show all",
      "viewAll": "View all",
      "faqsHeading": "FAQs",
      "categoryTag": "Blog",
      "emptyStrip": "Related posts are coming soon.",
      "medicalDisclaimer": "This article is for general information. It is not medical advice, a diagnosis, or a treatment plan. Talk with a clinician before you change medication, supplements, or how you manage a sleep problem.",
      "medicalDisclaimerLink": "Read our medical disclaimer"
    },
    "chrome": {
      "nav": "nav",
      "sticky-top": "sticky-top.blog",
      "footer": "footer",
      "cookie-banner": "cookie-banner"
    },
    "humanSignoff": null
  },
  "es": {
    "_note": "Neutral Spanish, Mexico-first. `tú` never `vosotros`, never the verb `coger`.",
    "lang": "es",
    "inLanguage": "es-MX",
    "hreflang": "es",
    "base": "/es/blog",
    "hub": "/es",
    "collection": "blog-es",
    "overlayDir": "src/content/_es-overlays",
    "dateMonths": [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "dateTemplate": "{d} de {month} de {y}",
    "labels": {
      "published": "Publicado",
      "updated": "Actualizado",
      "writtenBy": "Escrito por ",
      "heroReviewedBy": "Revisado médicamente por",
      "medicallyReviewedBy": "Revisado médicamente por",
      "editorialReviewedBy": "Revisado editorialmente por",
      "editorialTeam": "Sobre nuestro equipo editorial",
      "references": "Referencias",
      "showAll": "Ver todas",
      "viewAll": "Ver todo",
      "faqsHeading": "Preguntas frecuentes",
      "categoryTag": "Blog",
      "emptyStrip": "Próximamente más artículos relacionados.",
      "medicalDisclaimer": "Este artículo es información general. No es consejo médico, un diagnóstico ni un plan de tratamiento. Habla con un profesional de la salud antes de cambiar medicamentos, suplementos o cómo manejas un problema de sueño.",
      "medicalDisclaimerLink": "Lee nuestro aviso médico"
    },
    "chrome": {
      "nav": "nav",
      "sticky-top": "sticky-top.blog.es",
      "footer": "footer",
      "cookie-banner": "cookie-banner.es"
    },
    "humanSignoff": [
      {
        "nativeReview": "2026-08-08",
        "hedgeAudit": "2026-08-08",
        "by": "Leon",
        "slugs": [
          "calculadora-de-sueno",
          "como-bajar-el-cortisol",
          "como-dejar-de-roncar",
          "como-quitarse-el-sueno",
          "conciliar-el-sueno",
          "cuantas-horas-hay-que-dormir",
          "dormir-4-horas-es-suficiente",
          "dormir-5-horas-es-suficiente",
          "dormir-6-horas-es-suficiente",
          "dormir-7-horas-es-suficiente",
          "fases-del-sueno",
          "mejor-posicion-para-dormir",
          "melatonina-para-que-sirve",
          "por-que-me-da-mucho-sueno",
          "ritmo-circadiano"
        ]
      },
      {
        "nativeReview": "2026-08-14",
        "hedgeAudit": "2026-08-14",
        "by": "Leon",
        "note": "Phase 2 batch. Reviewer completed the review; the flag was not recorded at the time.",
        "slugs": [
          "cuanto-debe-durar-una-siesta",
          "efectos-secundarios-de-la-melatonina",
          "levantarse-temprano",
          "magnesio-para-dormir",
          "pastillas-para-dormir-sin-receta",
          "por-que-bostezo-mucho",
          "sintomas-de-cortisol-alto"
        ]
      }
    ]
  },
  "pt": {
    "_note": [
      "Brazilian Portuguese. Portugal is deliberately NOT a separate locale: Search Console over 16 months",
      "shows Brazil 1,168,985 impressions against Portugal's 106,640 — eleven to one. Splitting a small",
      "corpus across two variants serves both worse than serving Portugal imperfectly with pt-BR.",
      "See internal-research-and-scripts/localization/PORTUGUESE-BR-TRANSLATION-BRIEF.md.",
      "",
      "`você`, always — never `tu`. That is the fastest way a Brazilian reader clocks European Portuguese.",
      "Brazilian orthography throughout, and Brazilian vocabulary on every split (`café da manhã`, not",
      "`pequeno-almoço`). Register runs warmer than the Spanish tree: the competitor to match on",
      "readability is tuasaude.com, which holds 7 of the 10 target SERPs, not MSD Manuals."
    ],
    "lang": "pt",
    "inLanguage": "pt-BR",
    "hreflang": "pt-BR",
    "base": "/pt/blog",
    "hub": "/pt",
    "collection": "blog-pt",
    "overlayDir": "src/content/_pt-overlays",
    "dateMonths": [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "dateTemplate": "{d} de {month} de {y}",
    "labels": {
      "published": "Publicado em",
      "updated": "Atualizado em",
      "writtenBy": "Escrito por ",
      "heroReviewedBy": "Revisado clinicamente por",
      "medicallyReviewedBy": "Revisado clinicamente por",
      "editorialReviewedBy": "Revisado editorialmente por",
      "editorialTeam": "Sobre nossa equipe editorial",
      "references": "Referências",
      "showAll": "Ver todas",
      "viewAll": "Ver tudo",
      "faqsHeading": "Perguntas frequentes",
      "categoryTag": "Blog",
      "emptyStrip": "Em breve, mais artigos relacionados.",
      "medicalDisclaimer": "Este artigo é informação geral. Não é conselho médico, diagnóstico nem um plano de tratamento. Fale com um profissional de saúde antes de mudar medicamentos, suplementos ou a forma como lida com um problema de sono.",
      "medicalDisclaimerLink": "Leia nosso aviso médico"
    },
    "chrome": {
      "nav": "nav",
      "sticky-top": "sticky-top.blog",
      "footer": "footer",
      "cookie-banner": "cookie-banner"
    },
    "humanSignoff": [
      {
        "nativeReview": "2026-08-09",
        "hedgeAudit": "2026-08-09",
        "by": "Leon",
        "slugs": [
          "cansaco-excessivo",
          "como-baixar-o-cortisol",
          "como-parar-de-roncar",
          "melatonina-para-que-serve"
        ]
      },
      {
        "nativeReview": "2026-08-14",
        "hedgeAudit": "2026-08-14",
        "by": "Leon",
        "note": "Phase 2 batch. Reviewer completed the review; the flag was not recorded at the time.",
        "slugs": [
          "cansaco-mental",
          "cortisol-alto-sintomas",
          "remedio-natural-para-dormir",
          "remedio-para-dormir-sem-receita"
        ]
      }
    ]
  }
}
